import Honeybadger from 'honeybadger-js';
import { createRoot } from 'react-dom/client';
import { Setup } from './components/SetupProvider';
import { initI18n } from './components/SetupProvider/i18n';
import Tracking from './components/SetupProvider/Tracking';
import './index.css';
import { isProduction } from './lib/environment';
import ContextContainer from './modules/global/components/ContextContainer';
import App from './modules/index/App';

(async () => {
  initI18n();

  Honeybadger.configure({
    apiKey: 'd948d6e7',
    environment: window.location.host,
    revision: (import.meta.env.VITE_BUILD_VERSION as string) ?? '',
    onerror: false,
    onunhandledrejection: false,
    maxErrors: 100,
    disabled: !isProduction,
    projectRoot: 'webpack:///./',
  });

  const container = document.getElementById('react-container');
  const root = createRoot(container!); // eslint-disable-line @typescript-eslint/no-non-null-assertion

  root.render(
    <Setup>
      <ContextContainer>
        <Tracking />
        <App />
      </ContextContainer>
    </Setup>,
  );
  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  // reportWebVitals();
})();
